import {useEffect, useState} from "preact/hooks";
import messages from "../messages/messages.js";
import {YouTubeThumbnail} from "./YouTubeThumbnail.jsx";

export function PlaylistsList({playlists, location}) {

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {playlists.map((playlist) => {
                const title = playlist.song?.title ?? playlist.title;
                return (
                    <a key={playlist.id} href={`/song?s=${playlist.youtube_url}&p=${playlist.id}`}
                       className="group text-white flex gap-3 items-center p-2 rounded-lg border border-border/60 bg-zinc-800 cursor-pointer">
                        <div className="w-[90px] h-[55px] min-w-[90px] overflow-hidden rounded-t-lg">
                            <YouTubeThumbnail
                                className="object-cover transition-transform group-hover:scale-110 w-full h-full"
                                youtubeId={playlist.youtube_url}
                                alt={title}
                            />
                        </div>
                        <div>
                            <div className="text-sm">{playlist.category_name}</div>
                            <div className="text-xs font-bold line-clamp-2">{title}</div>
                        </div>
                    </a>
                );
            })}
        </div>
    )
}
